import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Field} from '../interfaces/field';
import {Components, FieldPersonas} from "../../../../interfaces/personas-proyecto.interface";

@Injectable()
export class FormGroupBuilderService {
    toFormGroup(fields: Field<string>[]) {
        const group: any = {};
        fields.forEach((field) => {
            group[field.key] = this.applySettings(field);
        });
        return new FormGroup(group);
    }

    private applySettings(field: Field<string>) {
        if (field.completed) {
            return new FormControl({value: field.value || '', disabled: field.disabled});
        } else {
            return field.required ? new FormControl({
                value: field.value || '',
                disabled: false
            }, Validators.required) : new FormControl({value: field.value || '', disabled: false});
        }
    }

    toFormGroupPersonas(fields: FieldPersonas<string>[]): FormGroup {
        const group: any = {};

        fields.forEach((field) => {
            field.components.forEach((component) => {
                if (component.key) {
                    group[component.key] = this.applySettingsPersonas(component);
                } else {
                    console.warn(`El componente no tiene una propiedad 'key':`, component);
                }
            });
        });

        return new FormGroup(group);
    }

    private applySettingsPersonas(component: Components): FormControl {
        if (component.completed) {
            return new FormControl(
                { value: component.values?.[0]?.value || '', disabled: component.disabled }
            );
        } else {
            return component.required ? new FormControl({ value: component.values?.[0]?.value || '', disabled: component.disabled },
                    Validators.required
                )
                : new FormControl({ value: component.values?.[0]?.value || '', disabled: component.disabled }
                );
        }
    }

}
